import React, { useState } from "react";
import { PriPPLWise } from "../../../Components/KPI/PriPPLWise";
import First from "../../../Artifacts/ILMCVT.png";
import Second from "../../../Artifacts/SCVPU.png";
import Third from "../../../Artifacts/HCV.png";
import Fourth from "../../../Artifacts/ILMCV.png";
import { axInst } from "../../../Components/Login/Service";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Loader } from "rsuite";
import RetailpplModal from "../../../Components/Modals/RetailPplModal";

const fetchLob = async (body) => {
  try {
    const res = await axInst.post("stocks/lob-wise-stocks", body);
    return res.data.ppl_wise_stocks.ppl_wise_stocks;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const StockLobWise = () => {
  const { data, submitted } = useSelector((e) => e.filtersStock);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const {
    data: stockData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["ppl", submitted],
    queryFn: () => fetchLob(data),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const getTotal = (obj) => Object.values(obj || {}).reduce((a, b) => a + b, 0);
  const formatItems = (obj) =>
    Object.entries(obj || {}).map(([label, value]) => ({
      label,
      value,
    }));

  const handleItemClick = (label, icon, alt, darkcolor, title) => {
    setModalData({
      lob: [label],
      clickedLabel: label,
      icon,
      alt,
      darkcolor,
      Product_Line: title,
      api: "/stocks/ppl_wise_stocks",
    });
    setIsModalOpen(true);
  };

  return (
    <div className="grid grid-rows-[auto_1fr] px-2 pt-2 pb-3 bg-white rounded-md relative">
      <section className="flex justify-between pb-2">
        <header className="pb-2 text-base font-semibold text-[#545454]">
          LOB Wise Stocks
        </header>
      </section>
      <div className="grid gap-2 lg:grid lg:grid-cols-1 md:grid md:grid-cols-2 ">
        {isFetching && (
          <div className="grid items-center justify-center w-full h-full">
            <Loader />
          </div>
        )}
        {isError && <p>Error loading data</p>}
        {!isFetching && stockData && (
          <>
            <PriPPLWise
              onItemClick={(label) =>
                handleItemClick(
                  label,
                  First,
                  "ILMCV Trucks",
                  "bg-[#08B7C3] text-[#A2EDF2]",
                  "ILMCV Trucks",
                )
              }
              darkcolor={"bg-[#08B7C3] text-[#A2EDF2]"}
              color={"bg-[#A2EDF2]"}
              icon={First}
              alt={"ILMCV TRUCKS"}
              title={"ILMCV TRUCKS"}
              total={getTotal(stockData?.["ILMCV Trucks"])}
              items={formatItems(stockData?.["ILMCV Trucks"])}
            />

            <PriPPLWise
              onItemClick={(label) =>
                handleItemClick(
                  label,
                  Second,
                  "SCV  & PU",
                  "bg-[#4F81BA] text-[#DBECFF]",
                  "SCV  & PU",
                )
              }
              darkcolor={"bg-[#4F81BA] text-[#DBECFF]"}
              color={"bg-[#DBECFF]"}
              icon={Second}
              alt={"SCV & PU"}
              title={"SCV & PU"}
              total={getTotal(stockData?.["SCV & PU"])}
              items={formatItems(stockData?.["SCV & PU"])}
            />

            <PriPPLWise
              onItemClick={(label) =>
                handleItemClick(
                  label,
                  Second,
                  "HCV TRUCKS",
                  "bg-[#ccad5e] text-[#fff3d4]",
                  "HCV TRUCKS",
                )
              }
              darkcolor={"bg-[#ccad5e] text-[#fff3d4]"}
              color={"bg-[#fff3d4]"}
              icon={Third}
              image={"py-4"}
              alt={"HCV TRUCKS"}
              title={"HCV TRUCKS"}
              total={getTotal(stockData?.["HCV Trucks"])}
              items={formatItems(stockData?.["HCV Trucks"])}
            />
            <PriPPLWise
              onItemClick={(label) =>
                handleItemClick(
                  label,
                  Fourth,
                  "CV Passengers",
                  "bg-[#FF8E33] text-[#FFC699]",
                  "CV Passengers",
                )
              }
              darkcolor={"bg-[#FF8E33] text-[#FFC699]"}
              color={"bg-[#FFC699]"}
              icon={Fourth}
              alt={"CV Passengers"}
              title={"CV Passengers"}
              total={getTotal(stockData?.["CV Passenger"])}
              items={formatItems(stockData?.["CV Passenger"])}
            />
          </>
        )}
      </div>
      {isModalOpen && (
        <RetailpplModal
          closeModal={() => setIsModalOpen(false)}
          modalData={modalData}
        />
      )}
    </div>
  );
};
